import { create } from "zustand";

interface NavigationState {
  activeButton: string;
  isCollapsed: boolean;
  subMenuStates: {
    flow: boolean;
    mypage: boolean;
  };
  setActiveButton: (button: string) => void;
  setIsCollapsed: (collapsed: boolean) => void;
  toggleSubMenu: (menu: "flow" | "mypage") => void;
  closeAllSubMenus: () => void;
}

export const useNavigationStore = create<NavigationState>((set) => ({
  activeButton: "",
  isCollapsed: false,
  subMenuStates: {
    flow: false,
    mypage: false,
  },
  setActiveButton: (button) => set({ activeButton: button }),
  setIsCollapsed: (collapsed) => set({ isCollapsed: collapsed }),
  toggleSubMenu: (menu) =>
    set((state) => ({
      subMenuStates: {
        ...state.subMenuStates,
        [menu]: !state.subMenuStates[menu],
        // 다른 메뉴는 닫기
        ...(menu === "flow" ? { mypage: false } : { flow: false }),
      },
    })),
  closeAllSubMenus: () =>
    set({
      subMenuStates: {
        flow: false,
        mypage: false,
      },
    }),
}));
